import { useEffect, useState } from "react";
import { subscribeToPathRunSamples } from "../services/monitoringService";

export default function usePathRunSamples(collectionId, pathId, runId) {
  const [samples, setSamples] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!collectionId || !pathId || !runId) {
      setSamples([]);
      return undefined;
    }
    setIsLoading(true);
    setError("");
    return subscribeToPathRunSamples(collectionId, pathId, runId, (nextSamples) => {
      setSamples(nextSamples);
      setIsLoading(false);
    }, (firebaseError) => {
      console.error("Unable to load path samples", firebaseError);
      setError(firebaseError?.code === "permission-denied"
        ? "Firestore permissions do not allow reading this path’s data subcollection."
        : "Samples for this path could not be loaded. Refresh and try again.");
      setIsLoading(false);
    });
  }, [collectionId, pathId, runId]);

  return { samples, isLoading, error };
}
